<template>
  <div class="d-flex w-100">
    <div
      class="row Counter d-inline-flex h-50  bg-white"
      :class="counterInnerClass"
    >
      <div
        class="counter-col col-3 border-end col-time text-center"
        v-if="fullLength"
      >
        <div class="time-counter">
          <span class="time fw-light text-primary fs-6 ">{{
            dateDiff.months
          }}</span>
        </div>
        <div class="time-type-counter">
          <span class="time-type text-secondary">{{ $t('common.months') }}</span>
        </div>
      </div>

      <div class="counter-col col-3 border-end col-time text-center">
        <div class="time-counter d-flex flex-column">
          <span class="time  text-primary fs-6 " v-if="fullLength">{{ dateDiff.days - dateDiff.months * 30 }}</span>
          <span class="time  text-primary fs-6" v-else>{{ dateDiff.days }}</span>
          <span class="time-type text-secondary">{{ $t('common.days') }}</span>
        </div>
      </div>

      <div class="counter-col col-3 border-end col-time text-center ">
        <div class="time-counter d-flex flex-column">
          <span class="time  text-primary fs-6">{{ dateDiff.hours }}</span>
          <span class="time-type text-secondary">{{ $t('common.hours') }}</span>
        </div>
      </div>
      <div class="counter-col col-3 border-end col-time text-center ">
        <div class="time-counter d-flex flex-column d-flex flex-column">
          <span class="time  text-primary fs-6">{{ dateDiff.minutes }}</span>
          <span class="time-type text-secondary">{{ $t('common.minutes') }}</span>
        </div>
      </div>
      <div class="counter-col col-3  col-time text-center ">
        <div class="time-counter d-flex flex-column d-flex flex-column">
          <span class="time text-primary fs-6 mr-2 p-0 m-0">{{
            dateDiff.seconds
          }}</span>
          <span class="time-type text-secondary ">{{ $t('common.seconds') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    setInterval(() => {
      this.dateDiffc();
    }, 1000);
  },
  props: {
    endDate: {
      type: Date,
    },
    fullLength: {
      type: Boolean,
    },
    counterInnerClass: {
      type: String,
    },
  },
  data() {
    return {
      dateDiff: { days: 0, hours: 0, minutes: 0, seconds: 0, months: 0 },
    };
  },
  methods: {
    dateDiffc() {
       // Get the current date and the target date
      const currentDate = new Date();
      const targetDate = new Date(this.endDate);

      // Get the total difference in milliseconds
      const diffInMilliseconds = targetDate - currentDate;

      if (diffInMilliseconds < 0) {
        this.dateDiff = { days: 0, hours: 0, minutes: 0, seconds: 0, months: 0 };
        return;
      }

      // Calculate the differences
      const months = targetDate.getMonth() - currentDate.getMonth() + (targetDate.getFullYear() - currentDate.getFullYear()) * 12;
      const days = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffInMilliseconds % (1000 * 60)) / 1000);

      // Format the output
      this.dateDiff = {
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds,
          months: months
      };
    },
  },
};
</script>
<style scoped="scoped">
.time-type {
  font-size: 10px;
}
.time {
  font-weight: 400;
  font-size: 20px !important;
  color: var(--primary-color) !important;
}

.Counter {
  box-shadow: 0px 0px 25px rgb(0 0 0 / 10%);
  height: 80px;
}
@media (max-width: 1024px) {
  .time-type {
    font-size: 8px;
  }
  .Counter .col-3 {
    padding: 7px 0 !important;
  }
  .time {
    font-size: 15px !important;
  }
}
@media (max-width: 767.98px) {
  .time-type {
    font-size: 8px;
  }
  .Counter .col-3 {
    padding: 7px 0 !important;
  }
  .time {
    font-size: 15px !important;
  }
  .col-time {
    padding: 0 !important;
  }

  .Counter {
    margin: 0px !important;
    width: 100%;
  }
}
</style>
